export const cacheKeys = {
    jwt: 'jwt',
    wxuser: 'wxuser',
    srcMemberId: 'srcMemberId',
    qdSrcMemberId: 'srcMemberId'
}
